export const techs = [
  "html",
  "css",
  "js",
  "ts",
  "nodeJs",
  "react",
  "next",
  "pwa",
  "redux",
  "graphql",
  "reactQuery",
  "socket",
  "vite",
  "babel",
  "webpack",
];
export const designs = ["sass", "bootstrap", "tailwind", "antDesign", "materialUI", "shadcnUI"];
export const tools = [
  "git",
  "gitHub",
  "gitLab",
  "vsCode",
  "postman",
  "swagger",
  "openApi",
  "googleAnalytics",
  "typedoc",
  "sentry",
  "jira",
  "jiraAlign",
  "trello",
  "figma",
  "adobeXD",
];
export const projects = [
  {
    title: "Banimode",
    imgSrc: "baniMode",
    url: "https://www.banimode.com",
    text: "Banimode is the largest online shopping center that specializes in clothing and fashion, and has worked with more Iranian and international brands to improve the online clothing shopping experience in Iran.",
  },
  {
    title: "Jeanswest",
    imgSrc: "jeanswest",
    url: "https://www.jeanswest.ir",
    text: "The Australian clothing brand Jeanswest was first imported to Iran by Ava Cotton Company and today it is considered the largest clothing and fashion chain store in Iran.",
  },
  {
    title: "Balcafe",
    imgSrc: "balCafe",
    url: "https://www.balcafe.com",
    text: "The Balcafe chain of cafes was established in Tehran to create a pleasant experience for Avaktan customers. While emphasizing quality, it offers its unique menu and luxurious recipes to customers in a calm and pleasant atmosphere.",
  },
  {
    title: "Aseman Sooye Persian",
    imgSrc: "asp",
    url: "https://asemanexpress.com/fa",
    text: "Aseman Sooye Parsian Express Air Transport Company serves as one of the most active operators in the field of express air transport (Courier Company).",
  },
];
